import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Popover, Card, Select, Skeleton, Rate } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams} from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import Parameters from 'shared/parameters';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import { CurrencyFormatter, GetOrderTag } from 'shared/services/Utility';
import { CheckCircleTwoTone, CloseCircleFilled } from '@ant-design/icons';
import deFlag from '../../../src/img/de-icon.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import openClose from '../../../src/img/open-close.png';
import imgClose from '../../../src/img/close.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"


interface Props {
    location: any;
}

const { Title, Text } = Typography;
const { confirm } = Modal;
const { Option } = Select;
export default function CoursesReport(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [selectedOrg, setSelectedOrg] = useState(null as any);
    const [pagination, setPagination] = useState({ page: 1, per_page: '50' } as any);
    const [total, setTotal] = useState(0);
    const [items, setItems] = useState([] as any[]);
    const [organizations, setOrganizations] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setlang] = useState('' as any);
    const RouteParams: any = useParams();
    const userType = new URL(window.location.href).searchParams.get('userType');
    const clickedCourses = new URL(window.location.href).searchParams.get('clickedCourses');
   
    const columns = [
        {
            title: t('genDict.name'),
            key: 'title',
            dataIndex: 'title',
        },
        {
            title: t('genDict.author'),
            key: 'author',
            dataIndex: ['author', 'name'],
        },

        {
            title: t('genDict.price'),
            key: 'price',
            dataIndex: 'price',
        },
        {
            title: t('genDict.salePrice'),
            key: 'sale_price',
            dataIndex: 'sale_price',
        },
        {
            title: t('genDict.plan'),
            key: 'plan',
            dataIndex: 'plan',
        },
        {
            title: t('genDict.isFeatured'),
            key: 'isFeatured',
            dataIndex: 'isFeatured',
            render: (a: number) => a ? <CheckCircleTwoTone/> : <CloseCircleFilled/>,
        },
        {
            title: t('genDict.numberOfCurriculums'),
            key: 'numberOfCurriculums',
            dataIndex: 'curriculums_count',
        },
        {
            title: t('genDict.numberOfContents'),
            key: 'numberOfContents',
            dataIndex: 'contents_count',
        },
        {
            title: t('genDict.numberOfPurchases'),
            key: 'numberOfPurchases',
            dataIndex: 'courses_purchased_count',
        },
        {
            title: t('genDict.status'),
            key: 'status',
            dataIndex: 'status',
        },
        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
    ];
    const refreshItems = () => {
        setFetching(true);
        let params = {
            ...pagination,
            filter_organization_id: selectedOrg,
            order: 'DESC',
            order_by: 'id',
            per_page:'all',
        }
        if(userType == 'student'){
             params = {
                ...pagination,
                filter_organization_id: selectedOrg,
                student_id: RouteParams['id'],
                order: 'DESC',
                order_by: 'id',
                per_page:'all',
            }
        }
        if(userType == 'instructor'){
             params = {
                ...pagination,
                filter_organization_id: selectedOrg,
                instructor_id: RouteParams['id'],
                order: 'DESC',
                order_by: 'id',
                per_page:'all',
            }
        }
        if(clickedCourses == 'true'){
            params = {
               ...pagination,
               filter_organization_id: selectedOrg,
               student_id: RouteParams['id'],
               order: 'DESC',
               order_by: 'id',
               per_page:'all',
               clicked_courses: true,
           }
       }
        API_SERVICE.fetchReports(params, 'courses').then(({
                                data: {
                                    data: {
                                        count,
                                        current_page,
                                        items,
                                        per_page,
                                        total,
                                    },
                                },
                            }) => {
            setItems(items);
            setTotal(total);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#courseReportList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                     
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":      t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                      
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        }).catch(e => {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }).finally(() => {
            setFetching(false);

        });
    };
    const fetchOrganizations = async () => {
        setFetching(true);
        try {
            const {
                data: {
                    data: {
                        items: o,
                    },
                },
            } = await API_SERVICE.fetchOrganizations({ per_page: 1000, order_by: 'id', page: 1, order: 'DESC' });
            setOrganizations(o);
            if (o.length) {
                setSelectedOrg(o[0].id);
            }
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        if (Parameters.Mode === 'SUPER_ADMIN') {
            fetchOrganizations();
        } else {
            refreshItems();
        }
    }, [userType]);
    useEffect(() => {
        if (selectedOrg) {
            refreshItems();
            setlang(localStorage.getItem('language'));
        }
    }, [selectedOrg, pagination, props.location,userType]);
    if(fetching){
        return <Skeleton active={true} />
    }
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                <div className={'list-page-wrapper'}>
                    <div className="container-fluid">
                        <div className={'d-flex justify-space-between mb-3'}>
                            <div className='col-md-12 p-0 d-flex align-items-center'>
                                <div className={lang == 'ar' ? '' : 'mr-4'}>
                                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                </div>
                                
                                <div className={lang == 'ar' ? 'mr-2' : 'mr-2'}>
                                    
                                        {userType == 'student' && <h3 className='mb-0'>{t('genDict.students')} {t('genDict.coursesReport')}</h3>}
                                        {userType == 'instructor' && <h3 className='mb-0'>{t('genDict.Instructor')} {t('genDict.coursesReport')}</h3>}
                                        {clickedCourses == 'true' && <h3 className='mb-0'>{t('genDict.userClicked')} {t('genDict.coursesReport')}</h3>}
                                        {!userType && !clickedCourses && <h3 className='mb-0'>{t('genDict.coursesReport')}</h3>}
                                    </div>
                            </div>
                            <div className='ml-auto'>
                                {
                                    Parameters.Mode === 'SUPER_ADMIN' && <Select value={selectedOrg} onChange={(e) => {
                                        setSelectedOrg(e);
                                        setPagination({ ...pagination, page: 1, total: 0 });
                                    }
                                    }>
                                        {
                                            organizations.map((o: any) => {
                                                return <Option value={o.id}>{o.name}</Option>;
                                            })
                                        }
                                    </Select>
                                }
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='bg-white p-3 br-5px'>
                                    <div className="row">
                                    <div className="col-md-12 pb-3">
                                        <div className="table-responsive table-br-5 box-shadow mt-2">
                                            <table id='courseReportList' className="table table-meetings table-report">
                                            <thead>
                                                <tr>
                                                <th className="text-uppercase text-secondary">{t('genDict.course')}</th>
                                                <th className="text-uppercase text-secondary">{t('genDict.category')}</th>
                                                <th className="text-uppercase text-secondary">{t('genDict.rating')}</th>
                                                <th className="text-uppercase text-secondary text-center">
                                                {t('genDict.CourseContent')}
                                                    <table className='table'>
                                                        <tr>
                                                            <th className="text-uppercase text-secondary">{t('genDict.video')}</th>
                                                            <th className="text-uppercase text-secondary">{t('genDict.Pdf')}</th>
                                                            <th className="text-uppercase text-secondary">{t('genDict.Ppt')}</th>
                                                            <th className="text-uppercase text-secondary">{t('genDict.Quiz')}</th>
                                                        </tr>
                                                    </table>
                                                </th>
                                                <th className="text-uppercase text-secondary text-center">
                                                {t('genDict.CourseClickCount')}
                                                    <table className='table'>
                                                        <tr>
                                                            <th className="text-uppercase text-secondary">{t('genDict.loggedinUser')}</th>
                                                            <th className="text-uppercase text-secondary">{t('genDict.guestUser')}</th>
                                                        </tr>
                                                    </table>
                                                </th>
                                                <th className="text-uppercase text-secondary">{t('genDict.Instructor')}</th>
                                                {userType != 'student' && <th className="text-uppercase text-secondary text-center">{t('genDict.EnrolledStudents')}</th>}
                                                {userType == 'student' && <th className="text-uppercase text-secondary text-center">{t('genDict.CompletePercentage')}</th>}
                                                {userType == 'student' && <th className="text-uppercase text-secondary text-center">{t('genDict.SubscribedAt')}</th>}
                                                {userType == 'student' && <th className="text-uppercase text-secondary text-center">{t('genDict.CompletedAt')}</th>}
                                                {/* <th className="text-uppercase text-secondary">Price</th>
                                                <th className="text-uppercase text-secondary">Selling Price</th> */}
                                                {/* <th className="text-uppercase text-secondary">To plan</th> */}
                                                {/* <th className="text-uppercase text-secondary text-center">Featured</th> */}
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.status')}</th>
                                                <th className="text-uppercase text-secondary text-center">{t('genDict.createdAt')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    items && items.map(item => {
                                                        //console.log(item);
                                                        return <tr>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    {/* <div className="mr-3">
                                                                        <img src={deFlag} className="uploaded-img-cat" height="40" width="40"/>
                                                                    </div> */}
                                                                    <div className="">
                                                                        <p className="mb-0"><span>{item?.title}</span></p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="text-secondary">{item?.category?.name}</td>
                                                            <td className="text-secondary" style={{minWidth:"135px"}}><Rate disabled allowHalf defaultValue={item?.avg_rating} /></td>
                                                            <td className="text-secondary">
                                                            <table className='table'>
                                                                <tr>
                                                                    <td className="text-uppercase text-secondary text-center">{item?.lecture_count}</td>
                                                                    <td className="text-uppercase text-secondary text-center">{item?.pdf_count}</td>
                                                                    <td className="text-uppercase text-secondary text-center">{item?.ppt_count}</td>
                                                                    <td className="text-uppercase text-secondary text-center">{item?.quiz_count}</td>
                                                                </tr>
                                                            </table>
                                                            </td>
                                                            <td className="text-secondary">
                                                            <table className='table'>
                                                                <tr>
                                                                    <td className="text-uppercase text-secondary text-center">
                                                                    <span role={item?.user_clicks == 0 ? '' : 'button'} className={item?.user_clicks == 0 ? 'text-secondary' : 'text-blue'} onClick={() => {
                                                                        if(item.user_clicks != 0){
                                                                            history.push(`/reports/students/${item?.id}?courseClickedLoggedinUser=true`)
                                                                        }
                                                                    }}>
                                                                        {item?.user_clicks}
                                                                    </span>
                                                                    </td>
                                                                    <td className="text-uppercase text-secondary text-center">{item?.guest_clicks}</td>
                                                                </tr>
                                                            </table>
                                                            </td>
                                                            <td className="text-secondary">{item?.author?.name}</td>
                                                            {userType != 'student' && <td className="text-secondary text-center">
                                                                <span role={item?.courses_purchased_count == 0 ? '' : 'button'} className={item?.courses_purchased_count == 0 ? 'text-secondary' : 'text-blue'} onClick={() => {
                                                                    if(item.courses_purchased_count != 0){
                                                                        history.push(`/reports/students/${item?.id}`)
                                                                    }
                                                                }}>
                                                                    {item?.courses_purchased_count}
                                                                </span>
                                                            </td>}
                                                            {userType == 'student' && <td className="text-secondary text-center">
                                                                <div className="circle-small mt-4">
                                                                    <a type='button' onClick={() => {
                                                                        history.push(`/reports/users/${RouteParams['id']}/course/${item?.id}`)
                                                                    }}>
                                                                        <div className="text">{Math.round(item?.completion_percentage)}%</div> 
                                                                        <svg>
                                                                            <circle className="bg" cx="40" cy="40" r="37"></circle>
                                                                            <circle className="progress two" cx="40" cy="40" r="37" style={{strokeDashoffset: -(((232 * item?.completion_percentage)/100)-232)}}></circle>
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                            </td>}
                                                            {userType == 'student' && <td className="text-secondary text-center">
                                                                {moment(item?.course_completion_detail?.started_at).format('DD MMMM, YYYY')}
                                                            </td>}
                                                            {userType == 'student' && <td className="text-secondary text-center">
                                                                {item?.course_completion_detail?.completed_at ? moment(item.course_completion_detail.completed_at).format('DD MMMM, YYYY') : '-'}
                                                            </td>}
                                                            {/* <td className="text-secondary">{item?.price}</td>
                                                            <td className="text-secondary">{item?.sale_price}</td> */}
                                                            {/* <td className="text-secondary">{item.plan}</td> */}
                                                            {/* <td className="text-center">
                                                                {item?.is_featured === 1 ? <img src={openClose} style={{width:'25px'}}/>: <img src={imgClose} style={{width:'25px'}}/> }
                                                            </td> */}
                                                            <td className="text-center">
                                                                {item.status === 'ACTIVE' ? <img src={activeBadge}/> : <img src={inactiveBadge}/>}
                                                            </td>
                                                            <td className="text-secondary">{moment(item?.created_at).format('DD MMMM, YYYY')}</td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    {/* <Row gutter={20} justify={'space-between'}>
                        <Col flex={'auto'}>
                            <Title level={3}>{t('genDict.coursesReport')}</Title>
                        </Col>
                        <Col>
                            {
                                Parameters.Mode === 'SUPER_ADMIN' && <Select value={selectedOrg} onChange={(e) => {
                                    setSelectedOrg(e);
                                    setPagination({ ...pagination, page: 1, total: 0 });
                                }
                                }>
                                    {
                                        organizations.map((o: any) => {
                                            return <Option value={o.id}>{o.name}</Option>;
                                        })
                                    }
                                </Select>
                            }
                        </Col>
                    </Row>
                    <Table loading={fetching} scroll={{ x: true }} pagination={{
                        onChange: (page, per_page) => {
                            setPagination({ ...pagination, page: page, per_page: per_page || pagination.per_page });
                        },
                        pageSize: pagination.per_page,
                        hideOnSinglePage: true,
                        total: total,
                    }} dataSource={items} columns={columns}/> */}
                </div>
                )
            }
        </AuthConsumer>
    );
}
